export default function Page() {
  return (
    <main>
      Sorry, the page
      <br />
      could not be loaded.
    </main>
  );
}
